import { LocationGenerics } from "router/location";
import SignatureModal from "pages/profile/signature";
import { useSearch } from "react-location";
import { useEmployee } from "hooks/data/use-employees";

export default function ViewSignatureContainer({
    open,
    setOpen,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
}) {
    const searchParams = useSearch<LocationGenerics>();
    const { employee, loading } = useEmployee({
        employeeId: searchParams?.id || "",
    });

    return (
        <SignatureModal
            open={open}
            setOpen={setOpen}
            mode="view"
            signature={employee?.signature}
            loading={loading}
        />
    );
}
